<template>
    <div>
        <div class="upload">
            <ul class="list-group mb-2" v-if="files.length > 0">
                <li class="list-group-item" v-for="file in files" :key="file.id" :class="{
                    'bg-success text-white': file.success,
                    'bg-danger text-white': file.error
                }">
                    <div class="float-start">
                        {{ file.name }}
                        <div v-if="file.error">
                            <div :key="index" v-for="(error, index) in file.error" class="text-xxs">
                                <Icon icon="exclamation-circle" /> {{ error }}
                            </div>
                        </div>
                        <span v-else-if="!file.success" class="text-muted ms-1">
                            <span v-if="file.uploading">{{ $t('dropzone.uploading') }}…</span>
                        </span>
                    </div>
                    <div class="float-end text-end">
                        <a href="#" @click.prevent="$refs.upload.remove(file)" class="text-dark" v-if="!file.success"><Icon icon="times" /></a>
                        <span v-else>{{ $t('dropzone.uploaded') }} <Icon icon="check" class="ms-1" /></span>
                    </div>
                </li>
            </ul>
            <file-upload
                    :class="{ 'd-none': hideAddButton }"
                    class="btn btn-light"
                    accept="image/*,application/pdf"
                    :multiple="multiple"
                    v-model="files"
                    @input-file="inputFile"
                    :drop="true"
                    ref="upload"
                    :input-id="'upload-' + ( Math.floor(Math.random() * 99999) + 1 )">
                <slot v-if="$slots.default"></slot>
                <template v-else>
                    <Icon icon="plus" class="me-1" />
                    {{ multiple ? $t('dropzone.button_multiple') : $t('dropzone.button') }}
                </template>
            </file-upload>
        </div>
    </div>
</template>

<script>
    import FileUpload from 'vue-upload-component'
    import Icon from '../Icons/Icon'

    export default {
        name: 'Dropzone',
        components: {
            Icon,
            FileUpload
        },
        props: {
            multiple: {
                type: Boolean,
                default: true
            },
            hideAddButton: {
                type: Boolean,
                default: false
            },
            value: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data: function () {
            return {
                files: [],
                filesObjects: []
            }
        },
        methods: {
            onSuccess(file) {
                this.$emit('success', file)
            },
            inputFile(newFile, oldFile) {
                if (newFile && !oldFile) {
                    // add
                    this.fileAdded(newFile)
                }
                if (newFile && oldFile) {
                    // update
                    this.fileUpdated(newFile)
                }
                if (!newFile && oldFile) {
                    // remove
                    this.fileRemoved(oldFile)
                }
            },
            fileAdded(file) {
                this.$emit('add', file)
            },
            fileUpdated(file) {
                this.$emit('update', file)
            },
            fileRemoved(file) {
                this.$emit('remove', file)
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    this.files = val
                }
            },
            files: function() {
                this.$emit('input', this.files)
            }
        }
    }
</script>